var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.photoURL)?_c('div',{staticClass:"image preview floatable-preview"},[_c('b-image',{staticClass:"preview__image",attrs:{"src":_vm.photoURL,"ratio":"1by1","rounded":true}}),_c('b-icon',{staticClass:"floating-camera-icon",attrs:{"icon":"camera"},nativeOn:{"click":function($event){return _vm.iconButtonClicked.apply(null, arguments)}}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }